import { SlideGroup } from '@/types/api/LessonOverview';
import { SLIDE_SHOW_MODEL_TYPES } from '@/components/shared/slide_shows/utils';

// todo: type
const buildInitialValues = (slideShow, modelType: string) => {
  if (slideShow.assignable[0]?.slideGroups?.length) {
    return {
      modelType,
      modelsToAssign: slideShow.assignable[0].slideGroups,
      slideShowSelect: slideShow.assignable[0].value,
    };
  }

  return {
    modelType,
    modelsToAssign: slideShow.assignable[0].value,
  };
};

export const lessonSlideShowInitialValues = slideShow => (
  buildInitialValues(slideShow, SLIDE_SHOW_MODEL_TYPES[slideShow.activityType])
);

export const unitSlideShowInitialValues = slideShow => (
  buildInitialValues(slideShow, slideShow.model_type)
);

export const slideGroupInitialValues = (slideGroup: SlideGroup) => ({
  modelType: SLIDE_SHOW_MODEL_TYPES[slideGroup.activityType],
  modelsToAssign: [`SlideGroup-${slideGroup.id}`],
  slideShowSelect: `SlideShow-${slideGroup.slideShowId}`,
});
